module.exports = __webpack_public_path__ + "img/logo3.b87650f9.png";